import useApiLoading from "@/hooks/common/general/legacy/use-api-loading";
import { ButtonIconCircle } from "@Components/game/settings/buttons/styled-components";
import ContainerWrapper from "@Components/generic/container-wrapper";
import Icon from "@Components/generic/icon";
import Section from "@Containers/shared/cards/section";
import { vrSettingsSections } from "@Containers/shared/settings/config";
import { Events } from "@Context/common/general/context";
import VRHeaderButtonType from "@Enums/VRHeaderButtonType";
import { faChevronRight } from "@fortawesome/pro-solid-svg-icons";
import useDemoAccount from "@hooks/common/user/use-demo-account";
import useI18n from "@i18n";
import { Button, capitalize, Container, Stack, Typography, useTheme } from "@mui/material";
import { Api } from "@Shared/schemas";
import { includes } from "lodash-es";
import { useEffect } from "react";

const Settings = () => {
  const theme = useTheme();
  const { i18n } = useI18n();
  const { isDemo } = useDemoAccount();

  const navigate = (path: string) => Events.app.navigate.emit({ path });
  const isKitsLoading = useApiLoading([Api.Avatars.UpdateKit]);

  useEffect(() => {
    Events.app.showHeaderButton.emit({ type: VRHeaderButtonType.BACK, title: i18n("settings.page.title") });
    return () => {
      Events.app.hideHeaderButton.emit();
    };
  }, []);

  return (
    <ContainerWrapper id="SETTINGS" sx={{ overflow: "visible" }}>
      <Container maxWidth="sm" sx={{ padding: theme.spacing(0, 0, 6) }}>
        <Stack spacing={5}>
          <Typography variant="text4xl700" color="dsBase.v200">
            {i18n("settings.page.title")}
          </Typography>
          {vrSettingsSections.map((section, index) => (
            <Section key={index} title={i18n(section.title)}>
              <Stack spacing={1.5}>
                {section.links.map((link, index) => {
                  const isKitSection = includes(["settings.page.link.my-kit", "settings.page.link.default-kit"], link.title);
                  return (
                    <Button
                      key={index}
                      color="secondary"
                      fullWidth
                      onClick={() => navigate(link.path)}
                      sx={{
                        padding: theme.spacing(2, 3.5, 2, 2),
                        borderRadius: theme.spacing(2),
                        textTransform: "none",
                      }}
                      disabled={isKitSection && (isKitsLoading || isDemo)} // Disable kit sections for demo accounts because they are not available
                      disableFocusRipple
                    >
                      <Stack direction="row" sx={{ width: "fill-available", justifyContent: "space-between" }}>
                        <Stack direction="row" alignItems="center" spacing={2}>
                          <ButtonIconCircle>
                            <Icon icon={link.icon} size="lg" color={theme.palette.dsBase.v200} />
                          </ButtonIconCircle>
                          <Typography variant="text1xl500" color="dsBase.v200">
                            {capitalize(i18n(link.title))}
                          </Typography>
                        </Stack>
                        <Icon icon={faChevronRight} size="sm" color={theme.palette.dsNeutral.v300} />
                      </Stack>
                    </Button>
                  );
                })}
              </Stack>
            </Section>
          ))}
        </Stack>
      </Container>
    </ContainerWrapper>
  );
};

export default Settings;
